export default __webpack_public_path__ + "static/media/watoday.6635497c.svg";